import Microfrontend from '../Microfrontend';

const BreadcrumbsMicrofrontend = Microfrontend<{ path: string }>({
  name: 'breadcrumbs',
  windowKey: '__mfe_Breadcrumbs',
});

export default BreadcrumbsMicrofrontend;
